import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class TeamSelectionService {

    constructor(
        private http: HttpClient
    ) { }

    updateTokensByTeam(user) {
        return this.http.post(environment.serverUrl + '/user/updateTokensByTeam', user);
    }
}



// WEBPACK FOOTER //
// ./src/app/team-selection/team-selection.service.ts